<template>
  <modal
    :title="
      pricePackage.dataCentreInternetPackageNumber
        ? 'Edit Package'
        : 'Add New Package'
    "
    ref="modifyPriceModal"
    size="modal-lg"
    @save="savePricePackage()"
  >
    <div class="row">
      <div class="form-group col-md-10">
        <label class="control-label"> Description </label>
        <input
          disabled
          type="text"
          class="form-control"
          v-model="pricePackage.description"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-10">
        <label class="control-label"> Label </label>
        <input
          type="text"
          class="form-control"
          v-model="pricePackage.description"
        />
      </div>
    </div>
    <div class="row">
      <div
        class="form-group col-md-10"
        v-if="pricePackage.dataCentreInternetPackageNumber"
      >
        <label class="control-label"> Expired </label>
        <v-select :options="['true', 'false']" v-model="expired"></v-select>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-10">
        <label class="control-label"> Bandwidth Package</label>
        <div class="input-group">
          <input type="text" v-model="bandwidth" class="form-control" />
          <div class="input-group-append">
            <span class="input-group-text">Mbit/s</span>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";
export default {
  props: {
    pricePackage: {
      type: Object,
      required: true,
    },
    contractTerms: {
      type: Array,
      required: true,
    }
  },
  computed: {
    expired: {
      get() {
        return this.pricePackage.expired.toString();
      },
      set(expired) {
        this.pricePackage.expired = expired;
      },
    },
    bandwidth: {
      get() {
        return this.speed_bitsToMbits(this.pricePackage.bandwidth);
      },
      set(bandwidth) {
        this.pricePackage.bandwidth = this.speed_mbitsToBits(bandwidth);
      },
    },
  },
  components: {
    Modal,
  },
  methods: {
    open() {
      this.$refs.modifyPriceModal.open();
    },
    getLabel({ name }) {
      return name;
    },
    savePricePackage() {
      this.$refs.modifyPriceModal.isLoading();
      this.$http.post(this.$config.aimsAPI + "pricing/pricepackages/save", this.pricePackage).then(
          (response) => {
            if (this.pricePackage.dataCentreInternetPackageNumber > 0) {
              this.showSuccess("Successfully Edited Package");
              this.$emit("packageEdited");
            } else {
              this.showSuccess("Successfully Added Package");
              this.$emit("packageAdded", response.data);
            }
          },
          (error) => {
            this.showError("Error Saving Pricing", error);
            console.error(error);
          }
        )
        .finally(() => {
          this.$refs.modifyPriceModal.close();
          this.$refs.modifyPriceModal.isLoading();
        });
    },
  },
};
</script>

<style>
</style>
